import * as types from './actionTypes';
import { beginAjaxCall, endAjaxCall } from './ajaxStatusActions';

import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IMaterial, ItableFiltersParams, ThunkResult } from '../models';

import { msalFetch } from '../components/auth/Auth-Utils';

import API from '../constants/apiEndpoints';
import { constants } from '../constants/constants';
import { replaceEmptyStringsWithNull } from '../helpers/cleanObjEmptyStrings';

let productsCancelSource: ReturnType<
    typeof Axios.CancelToken.source
> | null = null;

export function getProducts(): ThunkResult<any> {
    return (dispatch, getState) => {
        if (productsCancelSource) {
            productsCancelSource.cancel();
        }
        productsCancelSource = Axios.CancelToken.source();
        dispatch(beginAjaxCall());
        const {
            page,
            search,
            mainCategory,
            subCategory,
            brand,
            origin,
            standard
        } = getState().manageProduct.tableFilters;

        // `standard` is a multiselect: an array of options (with a defensive fallback for a
        // single option). The special 'no-standard' option maps to `noStandardOnly`; the API
        // combines it (OR) with any real standards that are also selected.
        const selectedStandards = Array.isArray(standard)
            ? standard
            : standard
            ? [standard]
            : [];
        const noStandardOnly = selectedStandards.some(
            o => o.value === 'no-standard'
        );
        const standardValues = selectedStandards
            .filter(o => o.value !== 'no-standard')
            .map(o => o.value);
        const payload = replaceEmptyStringsWithNull({
            page: page || 1,
            search,
            mainCategoryID: mainCategory ? mainCategory.value : '',
            subCategoryID: subCategory ? subCategory.value : '',
            brandID: brand ? brand.value : '',
            origin: origin ? origin.value : '',
            isApproved: true,
            standards: standardValues,
            noStandardOnly: noStandardOnly || null,
            pageSize: 100
        });

        const axiosOptions: AxiosRequestConfig = {
            method: 'post',
            cancelToken: productsCancelSource.token,
            data: payload
        };

        const url = API.GET.inventory.products;
        return msalFetch(url, axiosOptions)
            .then((data: AxiosResponse<any>) => {
                if (!data.data) {
                    throw new Error('missing data');
                } else {
                    dispatch({
                        type: types.GET_MANAGE_PRODUCT_SUCCESS,
                        products: data.data.result
                    });
                    dispatch({
                        type: types.PRODUCT_MANAGE_TOTAL_PAGES,
                        pages: data.data.pages
                    });
                }
            })
            .catch((error: any) => {
                if (Axios.isCancel(error)) {
                    dispatch(endAjaxCall());
                    return;
                }
                dispatch({
                    type: types.GET_MANAGE_PRODUCT_FAILED,
                    error,
                    axiosOptions
                });
                constants.handleError(error, 'get products');
                console.error(error);
            });
    };
}

export const setTableFilter = (filters: ItableFiltersParams) => ({
    type: types.SET_TABLE_FILTER_MANAGE_PRODUCT,
    filters
});

export const toggleEditProductModal = () => ({
    type: types.TOGGLE_MODAL_EDIT_PRODUCT
});

export const setSelectedManageProduct = (product: IMaterial) => ({
    type: types.SET_SELECTED_MANAGE_PRODUCT,
    product
});
